import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import { KgIcon } from '../../../../../components/text-icon';
import { CustomLoader } from '../../../../../components/custom-loader';

export const IcepackFilledFormView = ({
	icepacksOptions,
	isIcepacksLoading,
	icepacksFillersOptions,
	isIcepacksFillersLoading,
	icepacksStatesOptions,
	isIcepacksStatesLoading,
	modesOptions,
	isModesLoading,
	isLoading,
}) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="icepack-filled-form">
			<Grid.Row className="icepack-filled-form__row">
				<Grid.Column width={6} className="icepack-filled-form__column">
					Хладоэлемент
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="icepack-filled-form__column">
					<Field
						name="icepack_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={icepacksOptions}
						search
						loading={isIcepacksLoading}
						disabled={isIcepacksLoading}
						noResultsMessage="Хладоэлементы не найдены"
						placeholder="Выберите хладоэлемент"
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-filled-form__row">
				<Grid.Column width={6} className="icepack-filled-form__column">
					Тип наполнителя
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="icepack-filled-form__column">
					<Field
						name="filler_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={icepacksFillersOptions}
						search
						loading={isIcepacksFillersLoading}
						disabled={isIcepacksFillersLoading}
						noResultsMessage="Наполнители не найдены"
						placeholder="Выберите тип наполнителя"
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-filled-form__row">
				<Grid.Column width={6} className="icepack-filled-form__column">
					Состояние наполнителя
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="icepack-filled-form__column">
					<Field
						name="state_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={icepacksStatesOptions}
						search
						loading={isIcepacksStatesLoading}
						disabled={isIcepacksStatesLoading}
						noResultsMessage="Состояния не найдены"
						placeholder="Выберите состояние наполнителя"
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-filled-form__row">
				<Grid.Column width={6} className="icepack-filled-form__column">
					Температурный режим
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="icepack-filled-form__column">
					<Field
						name="mode_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={modesOptions}
						search
						loading={isModesLoading}
						disabled={isModesLoading}
						noResultsMessage="Температурные режимы не найдены"
						placeholder="Выберите температурный режим"
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-filled-form__row">
				<Grid.Column width={6} className="icepack-filled-form__column">
					Масса
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="icepack-filled-form__column">
					<Field
						name="weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите массу"
						icon={KgIcon}
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

IcepackFilledFormView.propTypes = {
	icepacksOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksLoading: PropTypes.bool.isRequired,
	icepacksFillersOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksFillersLoading: PropTypes.bool.isRequired,
	icepacksStatesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksStatesLoading: PropTypes.bool.isRequired,
	modesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
};
